<script lang="ts">
  import { useIntersectionObserver } from '@vueuse/core';
  import { ref, nextTick } from 'vue';

  function onIdle(cb = () => {}) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(cb);
    } else {
      setTimeout(() => {
        nextTick(cb);
      }, 300);
    }
  }
  export default {
    props: {
      renderOnIdle: Boolean,
      unrender: Boolean,
      minHeight: Number,
      unrenderDelay: {
        type: Number,
        default: 10000,
      },
      noSkeleton: {
        type: Boolean,
        default: false,
      },
      shape: {
        type: String,
        default: undefined,
      },
      rows: {
        type: Number,
        default: 1,
      },
    },
    setup(props) {
      const shouldRender = ref(false);
      const targetEl = ref();
      const fixedMinHeight = ref(0);
      let unrenderTimer: any;
      let renderTimer: any;
      const { stop } = useIntersectionObserver(
        targetEl,
        ([{ isIntersecting }]) => {
          if (isIntersecting) {
            // perhaps the user re-scrolled to a component that was set to unrender. In that case stop the unrendering timer
            clearTimeout(unrenderTimer);
            // if we're dealing underndering lets add a waiting period of 200ms before rendering. If a component enters the viewport and also leaves it within 200ms it will not render at all. This saves work and improves performance when user scrolls very fast
            if (props.unrender) {
              renderTimer = setTimeout(
                () => {
                  shouldRender.value = true;
                },
                props.unrender ? 200 : 0
              );
            } else {
              shouldRender.value = true;
            }

            if (!props.unrender) {
              stop();
            }
          } else if (props.unrender) {
            // if the component was set to render, cancel that
            clearTimeout(renderTimer);
            unrenderTimer = setTimeout(() => {
              fixedMinHeight.value = targetEl.value.clientHeight;
              shouldRender.value = false;
            }, props.unrenderDelay);
          }
        }
        // {
        //   rootMargin: '600px',
        // }
      );
      if (props.renderOnIdle) {
        onIdle(() => {
          shouldRender.value = true;
          if (!props.unrender) {
            stop();
          }
        });
      }
      return { targetEl, shouldRender, fixedMinHeight };
    },
  };
</script>

<template>
  <div ref="targetEl">
    <a-skeleton v-if="!shouldRender && !noSkeleton" :animation="true">
      <a-space direction="vertical" :style="{ width: '100%' }" size="large">
        <a-skeleton-shape v-if="shape" :shape="shape" />
        <a-skeleton-line v-else :rows="rows" :line-height="40" />
      </a-space>
    </a-skeleton>
  </div>
  <slot v-if="shouldRender" />
</template>
